import { render, staticRenderFns } from "./SectionNotifs.vue?vue&type=template&id=6396ba20&scoped=true&"
import script from "./SectionNotifs.vue?vue&type=script&lang=ts&"
export * from "./SectionNotifs.vue?vue&type=script&lang=ts&"
import style0 from "./SectionNotifs.vue?vue&type=style&index=0&id=6396ba20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396ba20",
  null
  
)

export default component.exports